export const MIME_TYPES = {
    MP4: 'video/mp4',
    HLS: 'application/x-mpegURL',
    DASH: 'application/dash+xml',
};